import { IndexPage } from './IndexPage';
import { ApprovalPage } from './ApprovalPage';

export {
    IndexPage,
    ApprovalPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Reviews/index.ts
 **/